import { Injectable } from '@angular/core';
import { EnvConfig } from '../interfaces/env-config';

@Injectable({
  providedIn: 'root'
})
export class EnvConfigService {

  constructor() { }
  private config!: EnvConfig;

  setConfig(config: EnvConfig) {
    this.config = config;
  }

  getConfig() {
    return this.config;
  }
}
 